import { Link, useLocation } from "react-router-dom";

export default function Header() {
	const location = useLocation();
	const isBeraterPage = location.pathname === "/berater";

	return (
		<section id="header" className="container">
			<div className="row align-items-center">
				<div className="col-6 logo">
					<Link to="/">
						<span>Findaro</span> Reisen
					</Link>
				</div>
				<div className="col-6 text-end">
					{!isBeraterPage && (
						<Link to="/berater" className="button">
							Berater:in werden
						</Link>
					)}
				</div>
			</div>
		</section>
	);
}
